var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.gray && _vm.$style.entry_gray},[_c('div',{class:_vm.$style.entry_wrap},_vm._l((_vm.list),function(menu,index){return _c('the-entry-menu',{key:index,attrs:{"data":menu}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }